import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AuthContext from "./context/AuthContext";
const defaultTheme = createTheme();
function Copyright(props) {
    return (<Typography
        variant="body2"
        sx={{
            color: "rgba(255,255,255,.55)", fontSize: 12,
        }}
        align="center"
        {...props}
    >
        Copyright © MGM eBuild Pvt Ltd {new Date().getFullYear()}
    </Typography>);
}
export default function Login() {
    const navigate = useNavigate();
    const {loginUser} = useContext(AuthContext);
    const [formError, setFormError] = useState(false);
    const [errorMsg, seterrorMsg] = useState("");
    const [isLicenseExpired, setIsLicenseExpired] = useState(false);
    const [loginData, setloginData] = useState({
        username: "", password: "",
    });
    useEffect(() => {
        const licenseExpiryDate = new Date("2027-12-31");
        const today = new Date();
        if (today > licenseExpiryDate) {
            setIsLicenseExpired(true);
        }
    }, []);
    const inputHandler = (event) => {
        setloginData({
            ...loginData, [event.target.name]: event.target.value,
        });
    };
    const buttonEnable = loginData.username !== "" && loginData.password !== "";
    const handleSubmit = (event) => {
        event.preventDefault();
        loginUser(event);
    };
    return (<ThemeProvider theme={defaultTheme}>

        <CssBaseline/>

        <Box
            sx={{
                minHeight: "100vh", width: "100%", display: "flex", /*
                     * Paddy green + deep green background
                     */
                background: "linear-gradient(135deg,#052e16 0%,#14532d 45%,#F4C430 100%)", overflow: "hidden",
            }}
        >

            {/* =====================================================
                    LEFT AGRICULTURE IMAGE PANEL
                ====================================================== */}

            <Box
                sx={{
                    display: {
                        xs: "none", md: "flex",
                    },
                    width: {
                        md: "55%", lg: "58%",
                    },
                    minHeight: "100vh",
                    position: "relative",
                    backgroundImage: "url('/agriculture-login.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    overflow: "hidden",
                }}
            >

                {/* Green overlay */}

                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        background: "linear-gradient(135deg, rgba(5,46,22,.88) 0%, rgba(20,83,45,.62) 45%, rgba(0,0,0,.30) 100%)",
                    }}
                />


                {/* Yellow / Paddy glow */}

                <Box
                    sx={{
                        position: "absolute",
                        width: 350,
                        height: 350,
                        borderRadius: "50%",
                        background: "rgba(244,196,48,.16)",
                        filter: "blur(100px)",
                        top: -120,
                        right: -100,
                        zIndex: 1,
                    }}
                />


                {/* =================================================
                        TOP BRANDING
                    ================================================== */}

                <Box
                    sx={{
                        position: "relative", zIndex: 2, p: {
                            md: 5, lg: 7,
                        },
                    }}
                >

                    <Box
                        sx={{
                            display: "flex", alignItems: "center", gap: 1.5,
                        }}
                    >


                        <Box>


                        </Box>

                    </Box>

                </Box>


                {/* =================================================
                        MAIN MESSAGE
                    ================================================== */}

                <Box
                    sx={{
                        position: "relative", zIndex: 2, p: {
                            md: 5, lg: 7,
                        }, pb: {
                            md: 7, lg: 9,
                        }, maxWidth: 750,
                    }}
                >

                    <Typography
                        sx={{
                            color: "#F4C430", fontSize: {
                                md: 14, lg: 16,
                            }, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", mb: 2,
                        }}
                    >
                        Government of Tamil Nadu
                    </Typography>


                    <Typography
                        sx={{
                            color: "#fff", fontWeight: 800, fontSize: {
                                md: 38, lg: 52,
                            }, lineHeight: 1.1, mb: 2,
                        }}
                    >
                        Intelligent Agriculture.
                        <br/>

                        <Box
                            component="span"
                            sx={{
                                color: "#F4C430",
                            }}
                        >
                            Better Decisions.
                        </Box>
                    </Typography>


                    <Typography
                        sx={{
                            color: "rgba(255,255,255,.82)", fontSize: {
                                md: 16, lg: 18,
                            }, lineHeight: 1.7, maxWidth: 600,
                        }}
                    >
                        AI-powered agricultural intelligence
                        for farmers, field officers and
                        decision makers across Tamil Nadu.
                    </Typography>


                    {/* Feature Pills */}

                    <Box
                        sx={{
                            display: "flex", flexWrap: "wrap", gap: 1, mt: 4,
                        }}
                    >

                        {["Farmers", "Crops", "Climate", "Field Intelligence", "AI Analytics",].map((item) => (<Box
                            key={item}
                            sx={{
                                px: 2,
                                py: .8,
                                borderRadius: 20,
                                background: "rgba(255,255,255,.10)",
                                border: "1px solid rgba(244,196,48,.25)",
                                backdropFilter: "blur(10px)",
                                color: "#fff",
                                fontSize: 12,
                                fontWeight: 600,
                            }}
                        >
                            {item}
                        </Box>))}

                    </Box>

                </Box>


                {/* Bottom */}

                <Box
                    sx={{
                        position: "absolute", bottom: 20, left: 30, zIndex: 3,
                    }}
                >

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,.55)", fontSize: 11,
                        }}
                    >
                        Digital Agriculture Intelligence Platform
                    </Typography>

                </Box>

            </Box>


            {/* =====================================================
                    RIGHT LOGIN PANEL
                ====================================================== */}

            <Box
                sx={{
                    width: {
                        xs: "100%", md: "45%", lg: "42%",
                    }, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", /*
                         * Dark green instead of white
                         */
                    background: "linear-gradient(145deg,#052e16 0%,#14532d 55%)", position: "relative", px: {
                        xs: 3, sm: 5, md: 6, lg: 8,
                    }, py: 5,
                }}
            >

                {/* Decorative yellow glow */}

                <Box
                    sx={{
                        position: "absolute",
                        width: 300,
                        height: 300,
                        borderRadius: "50%",
                        background: "rgba(244,196,48,.13)",
                        filter: "blur(100px)",
                        top: -100,
                        right: -100,
                    }}
                />


                <Box
                    sx={{
                        position: "absolute",
                        width: 250,
                        height: 250,
                        borderRadius: "50%",
                        background: "rgba(34,197,94,.16)",
                        filter: "blur(100px)",
                        bottom: -80,
                        left: -80,
                    }}
                />


                {/* =================================================
                        LOGIN CARD
                    ================================================== */}

                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        width: "100%",
                        maxWidth: 430, /*
                             * Previous glass style
                             */
                        background: "rgba(255,255,255,.08)",
                        backdropFilter: "blur(25px)",
                        WebkitBackdropFilter: "blur(25px)",
                        border: "1px solid rgba(255,255,255,.16)",
                        borderRadius: "30px",
                        p: {
                            xs: 3.5, sm: 5,
                        },
                        boxShadow: "0 25px 60px rgba(0,0,0,.35)",
                    }}
                >

                    {/* =================================================
                            LOGO
                        ================================================== */}

                    <Box
                        sx={{
                            display: "flex", flexDirection: "column", alignItems: "center",
                        }}
                    >

                        <Avatar
                            sx={{
                                width: 82,
                                height: 82,
                                bgcolor: "rgba(255,255,255,.10)",
                                border: "1px solid rgba(244,196,48,.35)",
                                mb: 2,
                                boxShadow: "0 0 30px rgba(244,196,48,.10)",
                                overflow: "hidden",
                            }}
                        >
                            <Box
                                component="img"
                                src="/logo-eagri.png"
                                alt="Agriculture Logo"
                                sx={{
                                    width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%",
                                }}
                            />
                        </Avatar>
                        <Typography
                            variant="h4"
                            sx={{
                                color: "#fff", fontWeight: 800, mb: 1, letterSpacing: ".3px",
                            }}
                        >
                            TN eAGRI AI
                        </Typography>


                        <Typography
                            sx={{
                                color: "rgba(255,255,255,.70)", mb: 4, textAlign: "center", fontSize: 14,
                            }}
                        >
                            Agriculture Intelligence Platform
                        </Typography>


                        {/* =================================================
                                ERROR
                            ================================================== */}

                        {isLicenseExpired ? (<Typography
                            sx={{
                                width: "100%",
                                color: "#FCA5A5",
                                background: "rgba(220,38,38,.12)",
                                border: "1px solid rgba(248,113,113,.25)",
                                borderRadius: "12px",
                                p: 1.5,
                                mb: 2,
                                textAlign: "center",
                                fontSize: 13,
                            }}
                        >
                            License Expired.
                            Contact Administrator.
                        </Typography>) : (formError && (<Typography
                            sx={{
                                width: "100%",
                                color: "#FCA5A5",
                                background: "rgba(220,38,38,.12)",
                                border: "1px solid rgba(248,113,113,.25)",
                                borderRadius: "12px",
                                p: 1.5,
                                mb: 2,
                                textAlign: "center",
                                fontSize: 13,
                            }}
                        >
                            {errorMsg}
                        </Typography>))}


                        {/* =================================================
                                LOGIN FORM
                            ================================================== */}

                        <Box
                            component="form"
                            noValidate
                            onSubmit={handleSubmit}
                            sx={{
                                width: "100%",
                            }}
                        >

                            {/* Username */}

                            <TextField
                                fullWidth
                                margin="normal"

                                label="Username"

                                name="username"

                                value={loginData.username}

                                onChange={inputHandler}

                                disabled={isLicenseExpired}

                                InputLabelProps={{
                                    sx: {
                                        color: "rgba(255,255,255,.70)", "&.Mui-focused": {
                                            color: "#F4C430",
                                        },
                                    },
                                }}

                                sx={{
                                    mb: 1.5, "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px",
                                        background: "rgba(255,255,255,.07)",
                                        color: "#fff",
                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,.18)",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "rgba(244,196,48,.55)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#F4C430", borderWidth: 2,
                                        },
                                    }, "& input": {
                                        color: "#fff",
                                    },
                                }}
                            />


                            {/* Password */}

                            <TextField
                                fullWidth
                                margin="normal"

                                type="password"

                                label="Password"

                                name="password"

                                value={loginData.password}

                                onChange={inputHandler}

                                disabled={isLicenseExpired}

                                InputLabelProps={{
                                    sx: {
                                        color: "rgba(255,255,255,.70)", "&.Mui-focused": {
                                            color: "#F4C430",
                                        },
                                    },
                                }}

                                sx={{
                                    mb: 1, "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px",
                                        background: "rgba(255,255,255,.07)",
                                        color: "#fff",
                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,.18)",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "rgba(244,196,48,.55)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#F4C430", borderWidth: 2,
                                        },
                                    }, "& input": {
                                        color: "#fff",
                                    },
                                }}
                            />


                            {/* =================================================
                                    SIGN IN
                                ================================================== */}

                            <Button
                                type="submit"

                                fullWidth

                                variant="contained"

                                disabled={!buttonEnable || isLicenseExpired}

                                endIcon={<ArrowForwardIcon/>}

                                sx={{
                                    mt: 3,
                                    height: 52,
                                    borderRadius: "14px",
                                    fontSize: 16,
                                    fontWeight: 700,
                                    textTransform: "none",
                                    color: "#17351F",
                                    background: "linear-gradient(90deg,#F4C430,#EAB308)",
                                    boxShadow: "0 8px 25px rgba(244,196,48,.22)",
                                    "&:hover": {
                                        background: "linear-gradient(90deg,#FACC15,#F4C430)",
                                    },
                                    "&.Mui-disabled": {
                                        background: "rgba(244,196,48,.30)", color: "rgba(255,255,255,.55)",
                                    },
                                }}
                            >
                                Sign In
                            </Button>


                            {/* =================================================
                                    CREATE ACCOUNT
                                ================================================== */}

                            <Button
                                fullWidth

                                variant="outlined"

                                sx={{
                                    mt: 2,
                                    height: 52,
                                    borderRadius: "14px",
                                    color: "#fff",
                                    borderColor: "rgba(244,196,48,.35)",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    "&:hover": {
                                        borderColor: "#F4C430", background: "rgba(244,196,48,.08)",
                                    },
                                }}

                                onClick={() => navigate("/user-register")}
                            >
                                Create Account
                            </Button>

                        </Box>


                        {/* Footer */}

                        <Box
                            sx={{
                                mt: 4,
                            }}
                        >
                            <Copyright/>
                        </Box>

                    </Box>

                </Box>

            </Box>

        </Box>

    </ThemeProvider>);
}